import { PDF_BASE_URL } from "../../../config";

const AI_EXPLAINED_V2_AUDIO_BASE_URL =
  `${PDF_BASE_URL}/static/audio/ai_explained/openai_echo_nova_ai_explained_v2`;

let activeAudio = null;

function buildNarrationUrl(language, narrationId) {
  const safeLanguage = language === "es" ? "es" : "en";
  return `${AI_EXPLAINED_V2_AUDIO_BASE_URL}/${safeLanguage}/${narrationId}.mp3`;
}

export function stopAIExhibitV2FixedNarration() {
  const audio = activeAudio;
  if (!audio) return;

  try {
    audio.pause();
    audio.currentTime = 0;
    audio.src = "";
  } catch (error) {
    console.warn("AI Explained V2 narration stop failed:", error);
  }

  activeAudio = null;
}

export function playAIExhibitV2FixedNarration({
  audioEnabled = true,
  language = "en",
  narrationId,
}) {
  if (!audioEnabled || !narrationId) return;

  stopAIExhibitV2FixedNarration();

  if (typeof Audio === "undefined") {
    console.warn("AI Explained V2 narration requires browser Audio support.");
    return;
  }

  const audio = new Audio(buildNarrationUrl(language, narrationId));
  audio.preload = "auto";
  activeAudio = audio;

  audio.onended = () => {
    if (activeAudio === audio) activeAudio = null;
  };

  audio.onerror = () => {
    if (activeAudio === audio) activeAudio = null;
    console.warn(`AI Explained V2 narration failed to load: ${language}/${narrationId}`);
  };

  const playPromise = audio.play();
  if (playPromise?.catch) {
    playPromise.catch((error) => {
      if (activeAudio === audio) activeAudio = null;
      console.warn("AI Explained V2 narration playback failed:", error);
    });
  }
}
